/**
 * Optimizes an image to a max width and height attempting to preserve quality and making sure that images cannot
 * be arbitrarily large.
 */
export function optimizeImageUrl(image, maxWidth = null, maxHeight = null) {
  if (!image.url || image.url.indexOf("cloudinary") === -1) return image.url;
  if (maxWidth) maxWidth = parseFloat(maxWidth * 2).toFixed(0);
  if (maxHeight) maxHeight = parseFloat(maxHeight * 2).toFixed(0);
  if (maxWidth && image.width && image.width > maxWidth) {
    return image.url.replace("image/upload/", `image/upload/q_auto:best,f_auto,w_${maxWidth}/`);
  } else if (maxHeight && image.height > maxHeight) {
    return image.url.replace("image/upload/", `image/upload/q_auto:best,f_auto,h_${maxHeight}/`);
  } else {
    return image.url;
  }
}


/** WEBPACK FOOTER **
 ** ./src/lib/Images.js
 **/